"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutBoxIteratorBase = void 0;
var errors_1 = require("@devexpress/utils/lib/errors");
var LayoutBoxIteratorBase = (function () {
    function LayoutBoxIteratorBase(subDocument, layout, intervalStart, intervalEnd) {
        this.layout = layout;
        this.subDocument = subDocument;
        this.intervalStart = intervalStart;
        this.intervalEnd = intervalEnd;
        this.lastModelPosition = -1;
    }
    LayoutBoxIteratorBase.prototype.isInitialized = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    LayoutBoxIteratorBase.prototype.resetToInterval = function (intervalStart, intervalEnd) {
        this.intervalStart = intervalStart;
        this.intervalEnd = intervalEnd;
        this.lastModelPosition = -1;
        return this.isInitialized();
    };
    LayoutBoxIteratorBase.prototype.moveNext = function (endRowConflictFlags, middleRowConflictFlags) {
        var _this = this;
        this.endRowConflictFlags = endRowConflictFlags.clone();
        this.middleRowConflictFlags = middleRowConflictFlags.clone();
        if (this.lastModelPosition < 0) {
            this.position = this.getNewLayoutPosition(this.intervalStart, this.endRowConflictFlags, this.middleRowConflictFlags);
            if (!this.position && this.endRowConflictFlags.atLeastOneIsFalse())
                this.position = this.getNewLayoutPosition(this.intervalStart, this.endRowConflictFlags.setDefault(true), this.middleRowConflictFlags);
            if (this.position) {
                this.lastModelPosition = this.position.getLogPosition();
                return true;
            }
        }
        if (this.lastModelPosition > this.intervalEnd || this.lastModelPosition < 0)
            return false;
        if (this.lastModelPosition == this.intervalEnd)
            return this.setBoundPosition(this.intervalEnd, this.position, function (boundPos) { return boundPos < _this.lastModelPosition; });
        var prevPosition = this.position.clone();
        if (!this.advancePosition())
            return this.position.charOffset != this.position.box.getLength() ?
                this.setBoundPosition(this.intervalEnd, prevPosition, function (boundPos) { return boundPos < _this.lastModelPosition; }) :
                false;
        var currModelPos = this.position.getLogPosition();
        if (currModelPos >= this.intervalEnd)
            return this.setBoundPosition(this.intervalEnd, prevPosition, function (boundPos) { return boundPos < _this.lastModelPosition; });
        this.lastModelPosition = currModelPos;
        return true;
    };
    LayoutBoxIteratorBase.prototype.movePrev = function (endRowConflictFlags, middleRowConflictFlags) {
        var _this = this;
        this.endRowConflictFlags = endRowConflictFlags.clone();
        this.middleRowConflictFlags = middleRowConflictFlags.clone();
        if (this.lastModelPosition < 0) {
            this.position = this.getNewLayoutPosition(this.intervalEnd, this.endRowConflictFlags, this.middleRowConflictFlags);
            if (!this.position && this.endRowConflictFlags.atLeastOneIsFalse())
                this.position = this.getNewLayoutPosition(this.intervalEnd, this.endRowConflictFlags.setDefault(true), this.middleRowConflictFlags);
            if (this.position) {
                this.lastModelPosition = this.position.getLogPosition();
                return true;
            }
        }
        if (this.lastModelPosition < this.intervalStart || this.lastModelPosition < 0)
            return false;
        if (this.lastModelPosition == this.intervalStart)
            return this.setBoundPosition(this.intervalStart, this.position, function (boundPos) { return boundPos > _this.lastModelPosition; });
        var prevPosition = this.position.clone();
        if (!this.advancePositionBack())
            return false;
        var currModelPos = this.position.getLogPosition();
        if (currModelPos <= this.intervalStart)
            return this.setBoundPosition(this.intervalStart, prevPosition, function (boundPos) { return boundPos > _this.lastModelPosition; });
        this.lastModelPosition = currModelPos;
        return true;
    };
    LayoutBoxIteratorBase.prototype.setBoundPosition = function (logPosition, prevPosition, boundFunc) {
        var layoutPosition = this.getNewLayoutPosition(logPosition, this.endRowConflictFlags, this.middleRowConflictFlags);
        if (!layoutPosition)
            layoutPosition = this.getNewLayoutPosition(logPosition, this.endRowConflictFlags.setDefault(true), this.middleRowConflictFlags);
        var modelPos = layoutPosition.getLogPosition();
        if (layoutPosition.equals(prevPosition) || boundFunc(modelPos)) {
            this.position = prevPosition;
            return false;
        }
        this.position = layoutPosition;
        this.lastModelPosition = modelPos;
        return true;
    };
    LayoutBoxIteratorBase.prototype.advancePosition = function () {
        if (this.position.boxIndex + 1 < this.position.row.boxes.length) {
            this.position.boxIndex++;
            this.position.box = this.position.row.boxes[this.position.boxIndex];
            this.position.charOffset = 0;
            return true;
        }
        if (this.position.advanceToNextRow(this.layout)) {
            this.position.boxIndex = 0;
            this.position.box = this.position.row.boxes[0];
            this.position.charOffset = 0;
            return true;
        }
        return false;
    };
    LayoutBoxIteratorBase.prototype.advancePositionBack = function () {
        if (this.position.charOffset != 0) {
            this.position.charOffset = 0;
            return true;
        }
        if (this.position.boxIndex > 0) {
            this.position.boxIndex--;
            this.position.box = this.position.row.boxes[this.position.boxIndex];
            this.position.charOffset = 0;
            return true;
        }
        if (this.position.advanceToPrevRow(this.layout)) {
            this.position.boxIndex = this.position.row.boxes.length - 1;
            this.position.box = this.position.row.boxes[this.position.boxIndex];
            this.position.charOffset = 0;
            return true;
        }
        return false;
    };
    return LayoutBoxIteratorBase;
}());
exports.LayoutBoxIteratorBase = LayoutBoxIteratorBase;
